import React from "react";
import html2canvas from "html2canvas";
import { useStores } from "../../store";
import topimage from "./top-removebg-preview.png";
import bottomimage from "./bottom-removebg-preview.png";
import badge from "./badge-removebg-preview.png";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { saveAs } from "file-saver";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { getLogoBySubdomain, getwebsiteUrl } from "../../services/white_label";
import { getDataFromLocalStorage } from "../../services/localStorage";
export default function CourseCertificate({
  userName,
  issueDate,
  courseTopic,
  autoDownload = true,
}) {
  const { CommonStore } = useStores();

  const [name, setName] = useState("");
  const [interviewTopic, setInterviewTopic] = useState("");
  const [date, setDate] = useState("");
  const [showDownloadButton, setShowDownloadButton] = useState(true);

  const location = useLocation(); // Get the current URL location
  // const query = queryString.parse(location.search);

  // console.log(query);
  useEffect(() => {
    const fetchData = async () => {
      const data = await getDataFromLocalStorage("certificate");
      console.log("data", data);
      setName(data?.name);
      setInterviewTopic(data?.interviewTopic);
      const timestmap = parseInt(data?.date);
      const date = new Date(timestmap);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const dateString = `${day}/${month}/${year}`;
      setDate(dateString);
    };

    fetchData();
    // setName(userName ?? query.name);
    // setInterviewTopic(courseTopic ?? query.interviewTopic);
    // const timestmap = parseInt(issueDate ?? query.date);
    // const date = new Date(timestmap);
    // const day = date.getDate();
    // const month = date.getMonth() + 1;
    // const year = date.getFullYear();
    // const dateString = `${day}/${month}/${year}`;
    // setDate(dateString);
    downloadConfirmation();
    CommonStore.setAskUserToDownloadCertificate(false);
  }, []);
  const confirmationShownRef = useRef(false);

  const downloadConfirmation = () => {
    if (!CommonStore.askUserToDownloadCertificate) return;
    if (!autoDownload) return;

    setTimeout(() => {
      const userConfirmation = window.confirm(
        "Are you sure you want to download the certificate?"
      );
      if (userConfirmation) {
        handleGenerateAndDownload();
      }
      CommonStore.setAskUserToDownloadCertificate(false);
    }, 2000);
  };

  const componentRef = useRef();
  const handleGenerateAndDownload = () => {
    html2canvas(componentRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        saveAs(blob, "certificate.jpg");
      });
    });
  };

  return (
    <div
      ref={componentRef}
      id="yourDivId"
      className="md:flex lg:flex hidden justify-center flex-col items-center w-full  absolute h-screen bg-[#525659]"
    >
      <Helmet>
        <meta name="viewport" content="width=1920,  initial-scale=1.0 " />
      </Helmet>
      <div className="w-[80vw]  bg-white flex flex-col items-center relative rounded-[20px] overflow-hidden">
        <img
          src={topimage}
          className="absolute h-[85%] top-[-250px] left-[-600px]"
          alt=""
        />
        <img
          src={bottomimage}
          className="absolute bottom-[-250px] right-[-600px] h-[85%] "
          alt=""
        />
        <div>
          <img src={getLogoBySubdomain(true)} className="w-48 mt-12" />
        </div>
        <div className="flex justify-center w-[90%] mt-10 ml-32">
          <div className="border-r border-[#D3AC39] p-14 ">
            <h2 className="text-[#D3AC39] text-4xl ml-[-50px] font-thin amsterdam">
              Certificate <br />
            </h2>
            <h2 className="text-[#D3AC39] text-3xl font-light text-end mt-5">
              on course completion
            </h2>
          </div>
          <div className="flex flex-col justify-center p-14 ">
            <h2 className="text-[#D3AC39] text-2xl font-light mb-5 ">
              This proudly certificate is awarded to <br />
            </h2>
            <h2 className="text-[#D3AC39]  mt-5 text-3xl font-thin amsterdam pb-1 pt-4">
              {name}{" "}
            </h2>
          </div>
        </div>
        <h1 className="mt-5 text-center text-[#263574]  font-normal opacity-70">
          This is awarded to you for completion of the{" "}
        </h1>{" "}
        <span className="font-medium text-4xl opacity-100 text-center text-[#263574]  ">
          {" "}
          "{interviewTopic}" Course
        </span>{" "}
        <h1 className="text-center text-[#263574]  font-normal opacity-70">
          {" "}
          on
        </h1>
        <p className="mt-3 bg-[#D3AC39] text-white py-1 px-3 pb-1">{date}</p>
        <img src={badge} className="h-24 mt-5 bottom-20 left-20" alt="" />
        <p className="mt-3 tracking-[5px] font-bold text-gray-800 pb-3">
          {getwebsiteUrl()}
        </p>
      </div>
      {/* {showDownloadButton && (
          <button
          className="flex justify-around items-center bg-primary text-white w-50 py-2 px-10 mt-5 font-bold rounded-md"
          onClick={navigateToCertificate}
        >
          <MdDownload className="text-white mx-2" /> Download certificate
        </button>
        )} */}
    </div>
  );
}
